// DS: i4.42
import React from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import IconWrap from '../../IconWrap';
const NonCommercial = (props)=>{
    const uniqueId = useUniqueId();
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "16",
        height: "16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#i442-${uniqueId})`
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.986 0c2.247 0 4.142.771 5.685 2.314C15.223 3.857 16 5.752 16 8c0 2.248-.762 4.119-2.286 5.614C12.095 15.205 10.185 16 7.985 16c-2.171 0-4.047-.79-5.628-2.371C.786 12.057 0 10.18 0 8c0-2.19.786-4.086 2.357-5.686C3.9.772 5.776 0 7.985 0ZM1.8 5.843A6.291 6.291 0 0 0 1.443 8c0 1.772.647 3.305 1.942 4.6 1.305 1.286 2.848 1.929 4.629 1.929 1.8 0 3.352-.652 4.657-1.957a5.854 5.854 0 0 0 1.1-1.4l-3.014-1.344c-.105.506-.36.917-.764 1.236a2.63 2.63 0 0 1-1.437.55v1.229h-.928v-1.229c-.886-.009-1.696-.328-2.429-.957l1.1-1.114c.524.486 1.12.728 1.786.728.276 0 .512-.061.708-.186.195-.123.293-.328.293-.614 0-.2-.072-.362-.215-.486L8.1 8.658l-.943-.429-1.271-.557L1.8 5.843Zm6.214-4.415c-1.819 0-3.357.643-4.614 1.929-.314.314-.61.671-.886 1.072L5.572 5.8c.133-.419.385-.755.757-1.007a2.526 2.526 0 0 1 1.3-.421v-1.23h.928v1.23c.734.038 1.4.285 2 .742L9.514 6.186c-.448-.314-.904-.471-1.371-.471-.248 0-.469.047-.664.142-.195.095-.293.257-.293.486 0 .067.024.133.071.2L8.271 7l.7.315 1.287.571 4.099 1.828c.134-.562.2-1.133.2-1.714 0-1.838-.638-3.386-1.914-4.643-1.267-1.286-2.81-1.929-4.629-1.929Z",
        fill: "currentColor"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `i442-${uniqueId}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M0 0h16v16H0z"
    })))));
};
NonCommercial.displayName = 'NonCommercial';
export default NonCommercial;
